<template lang="pug">
  Cognito(type="confirmSignUp")
    h2 Confirmar conta

    div(v-if="user")
      ChangePassword(:user="user", @passwordChanged="apply")

    div(v-else="")
      | Confirmando sua conta

</template>

<script>
import Auth from '@aws-amplify/auth'
import ChangePassword from './ChangePassword'
import Cognito from 'src/components/Cognito/MainScreens/Cognito'
import { configureCongito } from 'src/components/Cognito'

export default {
  props: {
    email: { type: String, required: true },
    tempPassword: { type: String, required: true }
  },
  data () {
    return {
      user: null
    }
  },
  async created () {
    try {
      const result = await this.$API.getAuthUserPool.save({ email: this.email })

      const { userPoolWebClientId, userPoolId } = result.data.success

      configureCongito({ userPoolId, userPoolWebClientId })

      this.user = await Auth.signIn(this.email, this.tempPassword)

      if (this.user.challengeName !== 'NEW_PASSWORD_REQUIRED') {
        throw new Error('Nn devia chegar aqui.')
      }
    } catch (e) {
      console.warn('erro ao logar usuário', e)
      if (e.code === 'UserNotFoundException') {
        this.$router.push('/cognito/login')
        this.$swal({
          type: 'warning',
          text: 'esse link não é mais válido'
        })
      } else {
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Usuário não encontrado')
      }
    }
  },
  methods: {
    async apply () {
      this.$swal({
        type: 'success',
        title: 'Conta confirmada',
        text: 'Agora você já pode acessar o sistema pontotel.'
      })
      this.$router.push('/cognito/login')
    }
  },
  components: { ChangePassword, Cognito }
}
</script>
